window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function() { dataLayer.push(arguments); };

// 设置默认的同意状态为拒绝
function initializeConsentMode() {
  gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied',
  });
}

// 更新同意状态为同意
function updateConsentMode() {
  gtag('set', 'wait_for_update', 500); // 等待500毫秒更新状态
  gtag('consent', 'update', {
    'ad_storage': 'granted',
    'analytics_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
  });
}

// 更新同意状态为拒绝
function rejectConsentMode() {
  gtag('consent', 'update', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied',
  });
}

// 显示同意弹窗
function showConsentBanner() {
  const consentBannerHTML = `
    <div id="consent-banner" style="position: fixed; bottom: 0; width: 100%; background: rgba(0, 0, 0, 0.9); color: #fff; padding: 15px; text-align: center; z-index: 9999;">
      <p style="font-size: 14px;color:#FFFFFF; margin: 0;">This website uses cookies essential for its technical functionality, which are always enabled. Additional cookies that enhance user experience, enable targeted advertising, or facilitate interactions with social networks and other websites will only be activated with your consent..<a href="policies/privacy-policy" style="color: #4CAF50; text-decoration: none; margin-left: 10px;">Learn more</a></p>
      <div style="margin-top: 10px;">
        <button id="accept-consent" style="background-color: #4CAF50; color: white; padding: 10px 20px; margin-right: 10px; border: none; cursor: pointer;">Accept</button>
        <button id="reject-consent" style="background-color: #f44336; color: white; padding: 10px 20px; border: none; cursor: pointer;">Reject</button>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', consentBannerHTML);
  bindConsentButtons();
}

// 绑定“同意”和“拒绝”按钮的点击事件
function bindConsentButtons() {
  document.getElementById('accept-consent').onclick = function() {
    window.updateConsentMode();
    document.getElementById('consent-banner').style.display = 'none';
    setConsentStatus('true');
  };

  document.getElementById('reject-consent').onclick = function() {
    window.rejectConsentMode();
    document.getElementById('consent-banner').style.display = 'none';
    setConsentStatus('false');
  };
}

function getConsentStatus() {
  return localStorage.getItem('consent_given') || document.cookie.replace(/(?:(?:^|.*;\s*)consent_given\s*\=\s*([^;]*).*$)|^.*$/, "$1");
}

function setConsentStatus(status) {
  localStorage.setItem('consent_given', status);
  document.cookie = `consent_given=${status}; path=/; max-age=31536000;`;
}

document.addEventListener('DOMContentLoaded', function() {
  window.initializeConsentMode();

  const consentGiven = getConsentStatus();
  if (consentGiven === null) {
    window.showConsentBanner();
  } else if (consentGiven === 'true') {
    window.updateConsentMode();
  } else {
    window.rejectConsentMode();
  }
});
